// @needs-native-review — best-effort translation
import type { Translations } from '../types';

export const ko: Translations = {
  'meta.gameTitle': 'Luminary',

  'howto.title': '게임 방법',
  'howto.pieces.heading': '구성 요소',
  'howto.pieces.source': '광원',
  'howto.pieces.mirror': '거울',
  'howto.pieces.switch': '스위치',
  'howto.pieces.exit': '출구',
  'howto.pieces.wall': '벽',
  'howto.controls.heading': '조작 방법',
  'howto.controls.clickSlot.line1': '칸을 클릭하세요',
  'howto.controls.clickSlot.line2': '거울 놓기',
  'howto.controls.dragMirror.line1': '거울을 드래그하세요',
  'howto.controls.dragMirror.line2': '회전',
  'howto.controls.rightClick.line1': '오른쪽 클릭',
  'howto.controls.rightClick.line2': '거울 제거',
  'howto.controls.hint': '마우스 휠: 1° 단위 미세 회전.   거울 탭: 15° 회전.',
  'howto.objective.line1': '모든 스위치를 비추면 출구 잠금이 풀립니다.',
  'howto.objective.line2': '그다음 출구를 클릭하세요. 가능한 적은 거울로 해결해 보세요.',

  'howtoColor.title': '색과 프리즘',
  'howtoColor.pieces.heading': '새 구성 요소',
  'howtoColor.pieces.prism': '프리즘',
  'howtoColor.pieces.redSwitch': '빨간 스위치',
  'howtoColor.pieces.yellowSwitch': '노란 스위치',
  'howtoColor.pieces.whiteSwitch': '하얀 스위치',
  'howtoColor.how.heading': '작동 방식',
  'howtoColor.how.line1': '하얀 광선은 빨강, 초록, 파랑의 빛을 동시에 전달합니다.',
  'howtoColor.how.line2': '프리즘은 세 면을 따라 하얀 빛을 세 개의 색 광선으로 나눕니다.',
  'howtoColor.how.line3': '놓인 프리즘을 클릭하면 입력 면의 방향을 회전할 수 있습니다.',
  'howtoColor.switches.line1': '스위치에는 색 점이 보입니다 — 그게 원하는 색입니다.',
  'howtoColor.switches.line2': '노란 스위치(빨강 + 초록 점)는 두 색이 동시에 도달해야 합니다.',
  'howtoColor.switches.line3':
    '하얀 스위치(세 색 모두)는 빨강, 초록, 그리고 파랑이 동시에 도달해야 합니다.',

  'options.hints.label': '퍼즐에서 힌트 각도 표시',
  'options.hints.help': '반사할 때마다 입사 광선과 반사 광선 사이의 각도를 표시합니다.',

  'level.01-intro.title': '안녕, 빛',
  'level.02-two-mirrors.title': '두 번의 꺾임',
  'level.03-corner.title': '길을 막은 벽',
  'level.04-two-targets.title': '두 개의 목표',
  'level.05-tight.title': '비좁다',
  'level.06-hello-color.title': '안녕, 색',
  'level.07-pick-a-side.title': '한쪽을 골라봐',
  'level.08-yellow.title': '노랑',
  'level.09-magenta.title': '마젠타',
  'level.10-spectrum.title': '스펙트럼',

  // PuzzleScene
  'puzzle.itemCounter': '{used}/{optimal}',
  'puzzle.hint.angleType.right': '직각',
  'puzzle.hint.angleType.acute': '예각',
  'puzzle.hint.angleType.obtuse': '둔각',
  'puzzle.hint.label': '{angle}°\n{type}',
};
